export default function getAltAxis(axis){return"x"===axis?"y":"x"}